import { render, staticRenderFns } from "./ProductKeywordDeliveryMgmt.vue?vue&type=template&id=5e055bad"
import script from "./ProductKeywordDeliveryMgmt.vue?vue&type=script&lang=js"
export * from "./ProductKeywordDeliveryMgmt.vue?vue&type=script&lang=js"
import style0 from "./ProductKeywordDeliveryMgmt.vue?vue&type=style&index=0&id=5e055bad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports